import { useState, useEffect } from 'react';
import Api from 'entities/helpers/api';
import { transformDonorSearchSummary } from 'apps/profile/components/enrichment/utils';

/**
 * Fetches high/low quality count breakdowns from the DonorSearch /summary API.
 * Returns parsed counts to be merged with GQL base data via transformDonorSearchData.
 */
const useDonorSearchSummary = (contactId, donorsearchProfileId) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!contactId || !donorsearchProfileId) {
      setData(null);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    Api.ENRICHMENT.SUMMARY.get({
      params: { donorsearch_profile_id: donorsearchProfileId },
      success: (response) => {
        if (cancelled) return;
        setData(transformDonorSearchSummary(response.data || response));
        setLoading(false);
      },
      error: (xhr, status, err) => {
        if (cancelled) return;
        setError(err || 'Failed to fetch DonorSearch data');
        setLoading(false);
      },
    });

    return () => {
      cancelled = true;
    };
  }, [contactId, donorsearchProfileId]);
  return { data, loading, error };
};

export default useDonorSearchSummary;
